
























































































import { PublicCourseDetails } from '@/jbi-shared/dto/jtms-public-course.dtos';
import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import BaseDivider from '@/jbi-shared/vue-components/BaseDivider.vue';
import { PackageSelection } from '@/store/modules/jtms/short-course-checkout/short-course-checkout.types';
import { RootState } from '@/store/store';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

@Component({
  components: {
    BaseButton,
    BaseDivider
  }
})
export default class PurchaseOrderSummary extends Vue {
  @Getter('course/isFreeCourse')
  isFreeCourse!: boolean;

  @Getter('course/isGroupRegistrationEnabled')
  groupRegistrationEnabled!: boolean;

  @Getter('course/hasCourseModules')
  hasCourseModules!: boolean;

  @Getter('course/currency')
  currency!: string;

  @State(({ course }: RootState) => course.publicCourseState.courseDetails)
  publicCourseDetails!: PublicCourseDetails;

  @State(
    ({ shortCourseCheckout }: RootState) => shortCourseCheckout.selectedPackages
  )
  selectedPackages!: PackageSelection[];

  @State(({ shortCourseCheckout }: RootState) => shortCourseCheckout.isLastStep)
  isLastStep!: boolean;

  totalAmount: number = 0;
  subtotal: number = 0;

  // JAAS-2803-TODO: Placeholder values for future implementation of GST and discounts
  // NOTE: GST is dependant on charge code service, for courses as products
  // Ideally, for GST, frontend should make an API call to backend to get
  // exact GST amount, same with discounts. Subject to change.
  gstPercentage: number = 10;
  gstAmount: number = 0;
  discountPercentage: number = 5;
  discountAmount: number = 0;
  discountName: string = 'EARLYBIRD5';

  get validSelections(): PackageSelection[] {
    return this.selectedPackages.filter((pkg) => pkg.quantity !== 0);
  }

  get courseName(): string {
    return this.publicCourseDetails
      ? this.publicCourseDetails.courseName
      : 'Course name not provided';
  }

  get formattedDateRange(): string {
    if (!this.publicCourseDetails) {
      return 'No dates provided.';
    }

    return [
      this.publicCourseDetails.courseStartDate,
      this.publicCourseDetails.courseEndDate
    ].join(' - ');
  }

  // get isRegistrationForCourseWithoutModules(): boolean {
  //   return !this.groupRegistrationEnabled && !this.hasCourseModules;
  // }

  get buttonLabel(): string {
    if (!this.isLastStep) {
      return 'Continue';
    }

    if (this.isFreeCourse) {
      return 'Register';
    }

    return 'Proceed to payment';
  }

  mounted() {
    // Reset subtotal
    this.subtotal = 0;
    this.calculateTotal();
  }

  applyDiscount() {
    // Make API call here, open modal, etc.
    console.log('Implement me');
  }

  /**
   * The following section contains placeholder implementations for the value calculations.
   * Please change this segment as per future requirements/needs. Strongly recommend using
   * API calls instead of doing calculations in frontend, but I'll let y'all cook.
   */
  // @Watch('gstAmount')
  // @Watch('discountAmount')
  calculateTotal() {
    this.calculateSubtotal();
    this.calculateDiscount();
    this.calculateGST();

    this.totalAmount = this.subtotal + this.gstAmount - this.discountAmount;
  }

  calculateSubtotal() {
    this.selectedPackages.forEach((item) => {
      this.subtotal += item.quantity * parseFloat(item.amount);
    });
  }

  @Emit('trigger-next')
  handleNextStep() {
    return;
  }

  @Watch('subtotal')
  calculateDiscount() {
    if (this.discountPercentage === 0) {
      return;
    }

    // Scaffold implementation, to (potentially) replace with API call
    this.discountAmount = this.subtotal * (this.discountPercentage / 100);
  }

  // Scaffold implementation, to (potentially) replace with API call
  @Watch('subtotal')
  calculateGST() {
    if (this.gstPercentage === 0) {
      return;
    }

    // GST should be applied after the discount
    this.gstAmount =
      (this.subtotal - this.discountAmount) * (this.gstPercentage / 100);
  }

  private formatCurrency(value: number): string {
    return value.toLocaleString('en-AU', {
      style: 'currency',
      currency: 'AUD'
    });
  }
}
